import React from "react";
import styled from "styled-components";
import Details from "./details";
import Financials from "./financials";
import SocialMedia from "./social-media";
import { Row, Col } from "components/shared/layout";
import Layout from "../../shared/card-layout";

const FormsContainer = styled.div`
  width: 100%;
`;

const Level1Form = ({ editable = true }) => {
  return (
    <FormsContainer>
      <Row xs={12}>
        <Col xs={12} lg={6}>
          <Layout
            style={{ height: "100%" }}
            title="Business details"
            required={editable}
          >
            <Details />
          </Layout>
        </Col>

        <Col xs={12} lg={6}>
          <Layout title="Additional Details" required={editable}>
            <SocialMedia editable={editable} />
          </Layout>
        </Col>
      </Row>
    </FormsContainer>
  );
};

const Level2Form = ({ editable = true }) => {
  return (
    <FormsContainer>
      <Row xs={12}>
        <Col xs={12} lg={6}>
          <Layout title="Banking Details" required={editable}>
            <Financials editable={editable} />
          </Layout>
        </Col>
      </Row>
    </FormsContainer>
  );
};

export {
  Level1Form,
  Level2Form,
};
